import React from "react";
import { Trans, useTranslation } from "react-i18next";

export default function LanguageSelection() {
    const { t, i18n } = useTranslation();

    const changeLanguage = (language) => {
        if (i18n.language === "eo") {
            i18n.changeLanguage("en");
        } else {
            i18n.changeLanguage("eo");
        }
    };
    return (
        <div>
            <button onClick={() => changeLanguage("en")}>
                {t("switch_language_btn")}
            </button>
        </div>
    );
}
